var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"1.75","y1":"4.25","x2":"18.25","y2":"4.25","stroke":"#FF007F","strokeWidth":"1.5","strokeLinecap":"round","key":0}),React.createElement("line",{"x1":"1.75","y1":"10.25","x2":"18.25","y2":"10.25","stroke":"#FF007F","strokeWidth":"1.5","strokeLinecap":"round","key":1}),React.createElement("line",{"x1":"1.75","y1":"16.25","x2":"18.25","y2":"16.25","stroke":"#FF007F","strokeWidth":"1.5","strokeLinecap":"round","key":2})]);
}

Hamburger.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
